export default "__VITE_ASSET__de7ae136__"